export const jobs = [
  {
    company: "NETFLIX",
    companyClass: "netflix",
    companyLogo: "/netflix.png",
    role: "Software Engineer (L4)",
    team: "Web & TV Player Team",
    desc: "Focusing on Infrastructure & Test Automation at Netflix. Built out dev tooling for PR validation and keeps the lights going for CI/CD workflows.",
  },
  {
    company: "Tableau Mobile, Slack",
    companyClass: "tableau",
    companyLogo: "/salesforce-tableau.png",
    role: "Software Engineer (MTS)",
    desc: "Primarily worked on Authentication flows on Tableau Mobile, and also worked on backend for building Tableau apps into Slack!",
  },
  {
    company: "WARNER BROS. DISCOVERY",
    companyClass: "wb",
    companyLogo: "/warner-bros-discovery.svg",
    role: "Software Developer II",
    team: "React Native Team",
    desc: "Worked on expanding the company's React Native cross-platform development tools, for companies including HBO Max.",
  },
];
